/* eslint-disable max-lines */

import { ExportOptions } from './inventory-count.type';
import { find, forEach, isEmpty, isEqual, size, reduce } from 'lodash';
import { ColumnState } from 'ag-grid-community/dist/lib/columnController/columnController';
import {
  IInventoryItemVenue,
  IUserConfig,
  NotificationType,
  USER_CONFIG_MODULE_NAME,
  USER_CONFIG_MODULE_TYPE,
} from '@app/shared/types';
import {
  TOASTER_ERROR_MESSAGE,
  TOASTER_TRANSACTION_FAILED_MESSAGE,
} from '@app/shared/constants';

export const dealInventoryCountPDFOptions = (
  columnState: ColumnState[],
  options: ExportOptions,
): ExportOptions => {
  const mapIdAndName = {
    'reporting_category_major.entity_id': 'reporting_category_major.name',
    'reporting_category_minor.entity_id': 'reporting_category_minor.name',
  };
  const columnNames = [];
  // init list view no user saved config should hide major or minor
  if (isEqual(options.mode, 'alphabetical') && isEmpty(columnState)) {
    columnNames.push('reporting_category_major.name');
    columnNames.push('reporting_category_minor.name');
  }
  if (
    isEqual(options.mode, 'alphabetical') &&
    !isEmpty(columnState) &&
    !isEmpty(options.columnsHideIds)
  ) {
    forEach(options.columnsHideIds, (item: string) => {
      const selectedColState = find(columnState, (colState: ColumnState) =>
        isEqual(colState.colId, item),
      );
      if (selectedColState && selectedColState.hide) {
        columnNames.push(mapIdAndName[item] || item);
      }
    });
  }

  return {
    ...options,
    columnsHideIds: columnNames,
  };
};

export const getItemNameWidth = (
  isAlphabetical: boolean,
  hideColumns: string[],
): string => {
  // Currently hide up to two columns
  if (!isAlphabetical || isEmpty(hideColumns)) {
    return '20.2%';
  }
  if (isAlphabetical && isEqual(size(hideColumns), 2)) {
    return '50.2%';
  }
  if (isAlphabetical && isEqual(size(hideColumns), 1)) {
    return '35.2%';
  }
};

export const findColumnConfig = (
  columnConfigs: IUserConfig[],
  moduleName: USER_CONFIG_MODULE_NAME,
): IUserConfig | null => {
  return find(
    columnConfigs,
    (c) =>
      (isEmpty(c.module_type) &&
        isEqual(c.module_name, USER_CONFIG_MODULE_TYPE.INVENTORY_COUNT)) ||
      isEqual(c.module_name, moduleName),
  );
};

export const flattenItems = (
  arr: Partial<IInventoryItemVenue>[] = [],
): Partial<IInventoryItemVenue>[] =>
  reduce(
    arr,
    (
      list: Partial<IInventoryItemVenue>[],
      { children, ...item },
    ): Partial<IInventoryItemVenue>[] => {
      if (item?.isInventoryItemGroupRow) list.push({ ...item, children });
      if (children) list.push(...flattenItems(children));

      return list;
    },
    [],
  );

export const dealCustomErrorsFn = (e, uiActions): void => {
  uiActions.showToasterMessage({
    type: NotificationType.ERROR,
    title: e?.title || TOASTER_ERROR_MESSAGE.title,
    body:
      e?.detail?.detail ||
      e?.meta?.message ||
      TOASTER_TRANSACTION_FAILED_MESSAGE,
  });
};
